// extracted by mini-css-extract-plugin
module.exports = {"component":"truncated-text_component__WNrm3","content":"truncated-text_content__gSWUc","link":"truncated-text_link__dGWBj"};